import * as XLSX from "xlsx";
import { gridFilteredSortedRowEntriesSelector } from "@mui/x-data-grid";
import { formatNumber } from '../../../reducer/actions/formatNumber';
import { formatPrice } from '../../../reducer/actions/formatPrice';

export const exportToXLSX = (rows: any, columns: any, apiRef: any, schema: any, searchParams: any) => {
  const columnHeaders = columns.map((col: any) => col.headerName);

  // 📌 Csak a szűrt és látható sorokat vesszük figyelembe
  const filteredSortedRowsAndIds = gridFilteredSortedRowEntriesSelector(apiRef);
  const visibleRows = filteredSortedRowsAndIds.map((row: any) => row?.model);

  // 📌 Sorok átalakítása XLSX formátumra
  const worksheetData = visibleRows.map((row: any) => {
    return columns.reduce((acc: any, col: any) => {
      let cellValue = row[col.field];

      if (typeof cellValue === "object" && cellValue !== null) {
        if (cellValue?.value_pp) {
          const items = [];
          if (cellValue?.value) {
            let price = formatNumber(cellValue?.value);
            const pp = formatNumber(cellValue?.value_pp);
            if (pp) {
              price = `${price} (${pp})`;
            }
            items.push(price);
          }
          if (cellValue?.currency?.name) {
            items.push(cellValue?.currency?.name);
          }
          cellValue = items.join(" ");
        }
        if (cellValue?.EUR || cellValue?.HUF) {
          const items = [];
          if (cellValue?.EUR) {
            items.push(`${formatPrice(cellValue?.EUR, true, true)} EUR`);
          }
          if (cellValue?.HUF) {
            items.push(`${formatPrice(cellValue?.HUF, false, true)} HUF`);
          }
          cellValue = items.join(", ");
        } else if (Array.isArray(cellValue)) {
          cellValue = cellValue.map((item) => {
            if(col.field === 'guide_reservations'){
              if(item?.guide?.phone){
                return `${item?.guide?.name} (${item?.guide?.phone})`;
              }
              return item?.guide?.name;
            }
            return item.name;
          }).join(", ");
        } else {
          cellValue = cellValue.name || "";
        }
      }

      acc[col.headerName] = cellValue ? cellValue : "";
      return acc;
    }, {});
  });

  // 📌 XLSX létrehozása
  const worksheet = XLSX.utils.json_to_sheet(worksheetData);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "DataGrid Export");

  // 📌 Fájlnév generálása
  let filename = schema?.pluralName || schema?.name;
  if (searchParams && searchParams.get("from") && searchParams.get("to")) {
    filename += `_${searchParams.get("from")}-${searchParams.get("to")}`;
  }

  // 📌 XLSX fájl mentése
  XLSX.writeFile(workbook, `${filename}.xlsx`);
};
